import { FC } from "react";
import { Heading, Stack } from "@chakra-ui/react";

import { formatDate } from "../../../../../utils";
import { useGetProfileQuery } from "../../../../../api/profile";
import { DEFAULT_PROFILE_TEXT, ProfileText } from "./ProfileText";
import { ProfilePageMainInfoError } from "./ProfilePageMainInfoError";
import { ProfilePageMainInfoPending } from "./ProfilePageMainInfoPending";

export const ProfilePageMainInfo: FC = () => {
  const { data, isPending, isError, error, refetch } = useGetProfileQuery();

  const format = { day: "2-digit", month: "2-digit", year: "numeric" } as Intl.DateTimeFormatOptions;
  const birthDate = data?.birthDate ? formatDate(new Date(data.birthDate), format) : "";
  const passportIssueDate = data?.passport?.issueDate ? formatDate(new Date(data.passport.issueDate), format) : "";

  if (isPending) {
    return <ProfilePageMainInfoPending />;
  }

  if (isError) {
    return <ProfilePageMainInfoError error={error} refetch={refetch} />;
  }

  return (
    <Stack pt="26px" color="brand.500" spacing={0}>
      <Heading mb="26px">Контакты</Heading>
      <ProfileText title="Телефон" text={data.phone} />
      <ProfileText title="Email" text={data.email} />

      <Heading mt="28px" mb="25px">Договор</Heading>
      <ProfileText
        title="Номер договора"
        text={data.contractNumber || DEFAULT_PROFILE_TEXT}
        isCopyEnabled={true}
      />

      <Heading mt="28px" mb="26px">Личные данные</Heading>
      <ProfileText title="ФИО" text={data.fio} />
      <ProfileText title="Дата рождения" text={birthDate} />
      <ProfileText title="Гражданство" text={data.citizenship} />
      <ProfileText title="Серия и номер паспорта" text={data.passport?.seriesNumber} />
      <ProfileText title="Дата выдачи паспорта" text={passportIssueDate} />
      <ProfileText title="Код подразделения" text={data.passport?.organizationCode} />
      <ProfileText title="Адрес регистрации" text={data.registrationAddress} />
    </Stack>
  );
};
